export default function TutorialModal({ step, currentStep, totalSteps, onPrev, onNext, onClose, isLast }) {
  const pct = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 103, display: "flex", alignItems: "center", justifyContent: "center", padding: 16, pointerEvents: "none" }}>
      <div style={{
        width: "100%", maxWidth: 460,
        background: "#04050f",
        border: "1px solid rgba(255,255,255,.08)",
        borderRadius: 14,
        boxShadow: "0 0 60px rgba(0,0,0,.8), 0 0 0 1px rgba(99,102,241,.1)",
        pointerEvents: "auto",
        position: "relative",
        overflow: "hidden",
        fontFamily: "ui-monospace,'SF Mono',Menlo,monospace",
      }}>
        <div style={{ position: "absolute", top: 0, left: 0, width: 18, height: 18, borderTop: "1px solid rgba(99,102,241,.5)", borderLeft: "1px solid rgba(99,102,241,.5)", pointerEvents: "none", zIndex: 5 }} />
        <div style={{ position: "absolute", bottom: 0, right: 0, width: 18, height: 18, borderBottom: "1px solid rgba(99,102,241,.5)", borderRight: "1px solid rgba(99,102,241,.5)", pointerEvents: "none", zIndex: 5 }} />

        <div style={{ padding: "14px 18px 12px", borderBottom: "1px solid rgba(255,255,255,.05)", display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 12 }}>
          <div>
            <div style={{ fontSize: 10, letterSpacing: ".18em", textTransform: "uppercase", color: "rgba(129,140,248,.8)", marginBottom: 6, fontWeight: 700 }}>◈ Tutoriel — Étape {currentStep + 1}/{totalSteps}</div>
            <div style={{ fontSize: 18, fontWeight: 900, color: "rgba(241,245,249,.97)", fontFamily: "ui-sans-serif,system-ui", letterSpacing: "-.01em", lineHeight: 1.2 }}>{step.title}</div>
            {step.description && (
              <div style={{ fontSize: 12, color: "rgba(148,163,184,.75)", fontFamily: "ui-sans-serif,system-ui", marginTop: 5 }}>{step.description}</div>
            )}
          </div>
          <button onClick={onClose}
            style={{ width: 28, height: 28, borderRadius: 6, border: "1px solid rgba(255,255,255,.08)", background: "rgba(255,255,255,.04)", color: "rgba(148,163,184,.7)", fontSize: 11, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            ✕
          </button>
        </div>

        <div style={{ padding: "14px 18px" }}>
          {step.content}
        </div>

        <div style={{ padding: "0 18px 12px" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 9, color: "rgba(148,163,184,.65)", marginBottom: 6, letterSpacing: ".1em", fontWeight: 700 }}>
            <span>PROGRESSION</span>
            <span style={{ color: "rgba(165,180,252,.85)", fontWeight: 700 }}>{Math.round(pct)}%</span>
          </div>
          <div style={{ height: 3, borderRadius: 2, background: "rgba(255,255,255,.05)", overflow: "hidden" }}>
            <div style={{ height: "100%", width: `${pct}%`, borderRadius: 2, background: "linear-gradient(90deg,rgba(99,102,241,.8),rgba(6,182,212,.8))", transition: "width .35s ease", boxShadow: "0 0 8px rgba(99,102,241,.4)" }} />
          </div>
          <div style={{ display: "flex", gap: 4, marginTop: 10, justifyContent: "center" }}>
            {Array.from({ length: totalSteps }).map((_, i) => (
              <div key={i} style={{
                width: i === currentStep ? 14 : 5,
                height: 5, borderRadius: 3,
                background: i < currentStep ? "rgba(52,211,153,.6)" : i === currentStep ? "rgba(99,102,241,.9)" : "rgba(255,255,255,.1)",
                transition: "all .25s",
                boxShadow: i === currentStep ? "0 0 6px rgba(99,102,241,.6)" : "none",
              }} />
            ))}
          </div>
        </div>

        <div style={{ padding: "12px 18px 14px", borderTop: "1px solid rgba(255,255,255,.05)", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10 }}>
          <button onClick={onPrev} disabled={currentStep === 0}
            style={{
              padding: "9px 16px", borderRadius: 7, cursor: currentStep === 0 ? "not-allowed" : "pointer",
              border: "1px solid rgba(255,255,255,.08)", background: "rgba(255,255,255,.04)",
              color: currentStep === 0 ? "rgba(100,116,139,.4)" : "rgba(148,163,184,.8)",
              fontSize: 11, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase",
              transition: "all .15s",
            }}>
            ← Précédent
          </button>
          <button onClick={onNext}
            style={{
              padding: "9px 20px", borderRadius: 7, cursor: "pointer",
              border: isLast ? "1px solid rgba(52,211,153,.45)" : "1px solid rgba(99,102,241,.45)",
              background: isLast
                ? "repeating-linear-gradient(45deg,rgba(52,211,153,.04) 0,rgba(52,211,153,.04) 1px,transparent 1px,transparent 7px),rgba(52,211,153,.12)"
                : "repeating-linear-gradient(45deg,rgba(99,102,241,.04) 0,rgba(99,102,241,.04) 1px,transparent 1px,transparent 7px),rgba(99,102,241,.14)",
              color: isLast ? "rgba(110,231,183,.95)" : "rgba(165,180,252,.95)",
              fontSize: 11, fontWeight: 800, letterSpacing: ".08em", textTransform: "uppercase",
              clipPath: "polygon(6px 0%,100% 0%,calc(100% - 6px) 100%,0% 100%)",
              boxShadow: isLast ? "0 0 14px rgba(52,211,153,.12)" : "0 0 14px rgba(99,102,241,.12)",
              transition: "all .15s",
            }}>
            {isLast ? "✅ J'ai compris" : "Suivant →"}
          </button>
        </div>
      </div>
    </div>
  );
}